
const CATALOG_ARG = 'version_catalog';

export default {
  CATALOG_ARG,
  VALID_ARGS: new Set([CATALOG_ARG]),
};
